import * as types from "../constants/actionTypes";
import { LOCATION_CHANGE } from "react-router-redux";
import initialState from "./initialState";

export default (state = initialState.contactUsSubmitingStatus, action) => {
  switch (action.type) {
    case types.START_CONTACT_US_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.CONTACT_US_REQUEST_HAS_FAILED:
      return {
        error: true,
        loading: false,
        succeed: false
      };
    case types.CONTACT_US_REQUEST_HAS_SUCCEED:
      return {
        error: false,
        loading: false,
        succeed: true
      };
    case types.CHANGE_DISPLAY_ROOM:
    case LOCATION_CHANGE:
      return {
        error: false,
        loading: false,
        succeed: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/contactUsReducer.js